import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid'

export default function KPICard({
  title,
  value,
  subtitle,
  trend,
  icon: Icon,
  colorScheme = 'default'
}) {
  const colorClasses = {
    default: 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
    success: 'bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400',
    warning: 'bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400',
    danger: 'bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400'
  }

  return (
    <div className="card p-6">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
            {title}
          </p>
          <p className="mt-2 text-xl sm:text-2xl font-bold text-gray-900 dark:text-white break-words">
            {value}
          </p>

          {trend && (
            <div className="mt-2 flex items-center gap-1">
              {trend.direction === 'up' ? (
                <ArrowUpIcon className="w-4 h-4 text-green-500" />
              ) : (
                <ArrowDownIcon className="w-4 h-4 text-red-500" />
              )}
              <span
                className={`text-sm font-medium ${
                  trend.direction === 'up'
                    ? 'text-green-600 dark:text-green-400'
                    : 'text-red-600 dark:text-red-400'
                }`}
              >
                {trend.value}
              </span>
              {trend.label && (
                <span className="text-sm text-gray-500 dark:text-gray-400">
                  {trend.label}
                </span>
              )}
            </div>
          )}

          {subtitle && !trend && (
            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
              {subtitle}
            </p>
          )}
        </div>

        {Icon && (
          <div className={`flex-shrink-0 p-3 rounded-lg ${colorClasses[colorScheme]}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </div>
  )
}
